import { useState, useRef } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";

const AcceptTermsDialog = ({ visible, onHide, userName, onAccept, loading }) => {
  const [proofFile, setProofFile] = useState(null);
  const fileInputRef = useRef(null);

  const handleHide = () => {
    setProofFile(null);
    onHide();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) setProofFile(file);
    e.target.value = "";
  };

  const footer = (
    <div className="flex gap-2 pt-2">
      <Button
        label="Cancel"
        icon="pi pi-times"
        outlined
        severity="secondary"
        className="flex-1"
        onClick={handleHide}
        disabled={loading}
      />
      <Button
        label="Accept Terms"
        icon="pi pi-check"
        className="flex-1"
        onClick={() => onAccept(proofFile)}
        disabled={!proofFile || loading}
        loading={loading}
      />
    </div>
  );

  return (
    <Dialog
      header={
        <div className="flex align-items-center gap-2">
          <i className="pi pi-file-edit" style={{ color: "var(--primary-color)", fontSize: "1.2rem" }} />
          <span>Accept Terms on Behalf</span>
        </div>
      }
      visible={visible}
      style={{ width: "460px" }}
      onHide={handleHide}
      footer={footer}
      closable={!loading}
    >
      <div className="flex flex-column gap-4">
        <div
          className="flex align-items-start gap-3 p-3 border-round"
          style={{ background: "var(--surface-ground)", border: "1px solid var(--surface-border)" }}
        >
          <i
            className="pi pi-user mt-1"
            style={{ color: "var(--primary-color)", fontSize: "1rem", flexShrink: 0 }}
          />
          <div>
            <p className="m-0 text-color-secondary text-sm">Accepting on behalf of</p>
            <p className="m-0 mt-1 font-semibold text-color">{userName}</p>
          </div>
        </div>

        <div>
          <label className="block font-medium text-sm mb-2 text-color">
            Proof file
            <span className="text-color-secondary font-normal ml-1">(PDF or image, max 10 MB)</span>
          </label>

          <input
            ref={fileInputRef}
            type="file"
            accept="application/pdf,image/*"
            style={{ display: "none" }}
            onChange={handleFileChange}
            disabled={loading}
          />

          <div
            className="flex align-items-center gap-2 border-round cursor-pointer"
            style={{
              border: `1.5px solid ${proofFile ? "var(--primary-color)" : "var(--surface-border)"}`,
              background: "var(--surface-card)",
              padding: "0.5rem 0.75rem",
              minHeight: "2.75rem",
              transition: "border-color 0.15s",
            }}
            onClick={() => !loading && fileInputRef.current?.click()}
            onMouseEnter={(e) => {
              if (!proofFile) e.currentTarget.style.borderColor = "var(--primary-color)";
            }}
            onMouseLeave={(e) => {
              if (!proofFile) e.currentTarget.style.borderColor = "var(--surface-border)";
            }}
          >
            <i
              className={proofFile ? "pi pi-file" : "pi pi-paperclip"}
              style={{
                color: proofFile ? "var(--primary-color)" : "var(--text-color-secondary)",
                fontSize: "1rem",
                flexShrink: 0,
              }}
            />

            <span
              className="flex-1 text-sm"
              style={{
                color: proofFile ? "var(--text-color)" : "var(--text-color-secondary)",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {proofFile ? proofFile.name : "No file chosen — click to browse"}
            </span>

            {proofFile ? (
              <Button
                icon="pi pi-times"
                rounded
                text
                severity="secondary"
                style={{ width: "1.75rem", height: "1.75rem", flexShrink: 0 }}
                onClick={(e) => {
                  e.stopPropagation();
                  setProofFile(null);
                }}
                disabled={loading}
                aria-label="Remove file"
              />
            ) : (
              <span
                className="text-sm border-round px-2 py-1"
                style={{
                  background: "var(--surface-ground)",
                  border: "1px solid var(--surface-border)",
                  color: "var(--text-color-secondary)",
                  flexShrink: 0,
                  fontSize: "0.78rem",
                }}
              >
                Browse
              </span>
            )}
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default AcceptTermsDialog;
